import { AxiosError } from 'axios';
import { useState } from 'react';
import { useQuery } from 'react-query';
import { getMineRoleOfFolder } from '../../apis/tms/share';
import { GROUP_ROLE_ACCESS } from '../../constant/QueryKeyName';
import { ROLE_ACCESS } from '../../constant/storage';

const useRoleAccess = (groupId: string | null, defaultRole: ROLE_ACCESS) => {
  const [mineRole, setMineRole] = useState<ROLE_ACCESS>(ROLE_ACCESS.Revoked);

  const roleQueryReturn = useQuery<ROLE_ACCESS>(
    [GROUP_ROLE_ACCESS, groupId],
    () => {
      return getMineRoleOfFolder({
        folderId: groupId as string,
      }) as Promise<ROLE_ACCESS>;
    },
    {
      enabled: !!groupId,
      retry(_failureCount, error) {
        if ((error as AxiosError)?.response?.status === 401) {
          if (_failureCount === 2) return false;
          return true;
        }
        return false;
      },
      onSuccess(data) {
        setMineRole(data);
      },
      onError() {
        setMineRole(ROLE_ACCESS.Revoked);
      },
      initialData: ROLE_ACCESS.Revoked,
    }
  );

  return {
    mineRole: !!groupId ? mineRole : defaultRole,
    roleQueryReturn,
  };
};

export default useRoleAccess;
